import tabs from './features/tabs';
import dropdown from './features/dropdown';

tabs('.js-tabs');
dropdown('.js-dropdown');
